// extracted by mini-css-extract-plugin
export default {"input":"S_-z","button":"T_-z","selected":"U_-z","unavailable":"V_-z","oos":"W_-z","paperCutDisabledOverlay":"X_-z","image":"Y_-z"};